import { Route } from '@angular/router';
import { portalClientesPersonalizeGuard } from './pages/login/portal-clientes-personalize.session';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './pages/login/portal-clientes-login-page.component'
      ).then((m) => m.PortalClientesLoginPageComponent),
  },
  {
    path: 'personalize-password',
    canActivate: [portalClientesPersonalizeGuard],
    loadComponent: () =>
      import(
        './pages/login/portal-clientes-login-page.component'
      ).then((m) => m.PortalClientesLoginPageComponent),
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import(
        './pages/login/portal-clientes-login-page.component'
      ).then((m) => m.PortalClientesLoginPageComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import(
        './pages/home/portal-clientes-home-page.component'
      ).then((m) => m.PortalClientesHomePageComponent),
  },
  {
    path: 'promotions',
    loadComponent: () =>
      import(
        './pages/promotions/portal-clientes-promotions-page.component'
      ).then((m) => m.PortalClientesPromotionsPageComponent),
  },
  {
    path: 'promotions/:promotionId',
    loadComponent: () =>
      import(
        './pages/promotions/detail/portal-clientes-promotion-detail.component'
      ).then((m) => m.PortalClientesPromotionDetailComponent),
  },
  {
    path: 'departments',
    loadComponent: () =>
      import(
        './pages/departments/portal-clientes-departments-page.component'
      ).then((m) => m.PortalClientesDepartmentsPageComponent),
  },
  {
    path: 'departments/:departmentId',
    loadComponent: () =>
      import(
        './pages/departments/detail/portal-clientes-department-detail.component'
      ).then((m) => m.PortalClientesDepartmentDetailComponent),
    loadChildren: () =>
      import(
        './pages/departments/detail/portal-clientes-department-detail.routes'
      ).then((m) => m.PORTAL_CLIENTES_DEPARTMENT_DETAIL_ROUTES),
  },
  {
    path: 'digital-signature',
    loadComponent: () =>
      import(
        './pages/digital-signature/portal-clientes-digital-signature-page.component'
      ).then((m) => m.PortalClientesDigitalSignaturePageComponent),
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import(
        './pages/notifications/portal-clientes-notifications-page.component'
      ).then((m) => m.PortalClientesNotificationsPageComponent),
  },
  {
    path: 'service-requests',
    loadComponent: () =>
      import(
        './pages/service-requests/portal-clientes-service-requests-page.component'
      ).then((m) => m.PortalClientesServiceRequestsPageComponent),
  },
  {
    path: 'digital-assistance',
    loadComponent: () =>
      import(
        './pages/digital-assistance/portal-clientes-digital-assistance-page.component'
      ).then((m) => m.PortalClientesDigitalAssistancePageComponent),
  },
  {
    path: 'frequently-asked-questions',
    loadComponent: () =>
      import(
        './pages/frequently-asked-questions/portal-clientes-frequently-asked-questions-page.component'
      ).then((m) => m.PortalClientesFrequentlyAskedQuestionsPageComponent),
  },
  {
    path: 'personal-data',
    loadComponent: () =>
      import(
        './pages/personal-data/portal-clientes-personal-data-page.component'
      ).then((m) => m.PortalClientesPersonalDataPageComponent),
    loadChildren: () =>
      import(
        './pages/personal-data/portal-clientes-personal-data.routes'
      ).then((m) => m.PORTAL_CLIENTES_PERSONAL_DATA_ROUTES),
  },
  {
    path: 'legal-notices',
    loadComponent: () =>
      import(
        './pages/legal-notices/portal-clientes-legal-notices-page.component'
      ).then((m) => m.PortalClientesLegalNoticesPageComponent),
    loadChildren: () =>
      import('./pages/legal-notices/portal-clientes-legal-notices.routes').then(
        (m) => m.PORTAL_CLIENTES_LEGAL_NOTICES_ROUTES,
      ),
  },
  { path: 'documents', redirectTo: '/legal-notices', pathMatch: 'full' },
  { path: 'security', redirectTo: '/personal-data/security', pathMatch: 'full' },
];
